export function to_plain_text(value) {
  return String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim();
}

export function format_organization_type(value) {
  if (typeof value === "number") return "";

  return String(value || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
}

export function get_active_organization_id() {
  return localStorage.getItem("organization_id")
    || null;
}

export function get_retrieve_users_params() {
  const organization_id = get_active_organization_id();
  return organization_id ? { organization_id } : {};
}

export function append_active_organization_id(payload = {}) {
  const organization_id = get_active_organization_id();
  return organization_id
    ? Object.assign({}, payload, { organization_id })
    : payload;
}

export function append_active_organization_form_data(formData) {
  const organization_id = get_active_organization_id();
  if (organization_id) {
    formData.append("organization_id", organization_id);
  }
  return formData;
}

export function is_enabled_feature(value) {
  return value === true || value === "true" || value === 1 || value === "1";
}

export function is_organization_admin_role(user_details) {
  const role = user_details?.user_role;
  return String(role || "").trim().toLowerCase() === "organization admin";
}

export function parse_json_or_null(value) {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function first_present(...values) {
  return values.find((value) => value !== undefined && value !== null && String(value).trim() !== "") || "";
}

function unique_values(values) {
  return [...new Set(values.filter((value) => value !== undefined && value !== null && String(value).trim() !== ""))];
}

export function get_organization_branding_storage_keys({
  organization_id,
  profile_id,
  user_id,
} = {}) {
  const stored_organization_id = get_active_organization_id();
  const keys = unique_values([
    organization_id,
    stored_organization_id,
    profile_id,
    user_id,
    "current",
  ]);

  return keys.map((key) => `organization_branding_${key}`);
}

export function get_organization_branding(context = {}) {
  const keys = get_organization_branding_storage_keys(context);

  for (const key of keys) {
    const branding = parse_json_or_null(localStorage.getItem(key));
    if (branding) return branding;
  }

  return null;
}

export function save_organization_branding(branding, context = {}) {
  if (!branding) return;

  const serialized_branding = JSON.stringify(branding);
  get_organization_branding_storage_keys(context).forEach((key) => {
    localStorage.setItem(key, serialized_branding);
  });
}

export function remove_organization_branding(context = {}) {
  get_organization_branding_storage_keys(context).forEach((key) => {
    localStorage.removeItem(key);
  });
}
